import { Preferences } from '@capacitor/preferences';

const KEY = 'libellus.accessToken';

/**
 * Keeps the access token in memory for synchronous reads by the API client, backed by
 * Capacitor Preferences (native key-value storage on devices, localStorage on the web).
 */
let current: string | null = null;

export const tokenStore = {
  get(): string | null {
    return current;
  },

  async load(): Promise<string | null> {
    try {
      current = (await Preferences.get({ key: KEY })).value;
    } catch {
      current = null;
    }
    return current;
  },

  async save(token: string): Promise<void> {
    current = token;
    try {
      await Preferences.set({ key: KEY, value: token });
    } catch {
      // Storage can be unavailable (private mode); the session then lasts until reload.
    }
  },

  async clear(): Promise<void> {
    current = null;
    try {
      await Preferences.remove({ key: KEY });
    } catch {
      // Nothing to clear.
    }
  },
};
